import React, {useState} from 'react'
import {Button, Card, Tabs} from "antd";
import OutgoingTab from "./outgoingTab/OutgoingTab";
import OutgoingCreate from "./outgoingTab/OutgoingCreate";
import OutgoingShipping from "./shippingTab/OutgoingShipping";
import OutgoingDispatch from "./dispatchTab/OutgoingDispatch";

const {TabPane} = Tabs

const WarehouseOutgoingTabs = () => {
    const [newModal, setNewModal] = useState(false)
    const [updateList, setListUpdate] = useState(false)
    const [activeTab, setAvtiveTab] = useState('1');

    const addNewOutgoing = <Button onClick={() => setNewModal(!newModal)} type={'primary'} >Yeni Ekle</Button>

    const handlers = {
        updater(){
            setListUpdate(!updateList)
        },
        modalCloser(){
            setNewModal(!newModal)
        }
    };

    const handleTabChange = (key) => {
        setAvtiveTab(key);
    };

    return(
        <React.Fragment>
            <Card title={'Depo Çıkış'}>
                <Tabs tabBarExtraContent={addNewOutgoing} onChange={handleTabChange} defaultActiveKey={1}>
                    <TabPane tab={'Depo Çıkış'} key={1}>
                        {
                            activeTab === '1' &&  <OutgoingTab updateComponent={newModal}/>
                        }
                    </TabPane>
                    <TabPane tab={'Sevk Emirleri'} key={2} >
                       <OutgoingShipping />
                    </TabPane>
                    <TabPane tab={'İrsaliye Çıkış'} key={3}>
                        <OutgoingDispatch />
                    </TabPane>
                </Tabs>
            </Card>
            {newModal ? <OutgoingCreate show={newModal}  modalCloser={handlers.modalCloser} updater={handlers.updater} /> : null}
        </React.Fragment>
    )
}
export default WarehouseOutgoingTabs